import { render, staticRenderFns } from "./AccidentTechExpertForm.vue?vue&type=template&id=178aa4d0&scoped=true"
import script from "./AccidentTechExpertForm.vue?vue&type=script&lang=js"
export * from "./AccidentTechExpertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178aa4d0",
  null
  
)

export default component.exports